import { buildLegend, buildTooltip, mergeRadarSettings, } from "./shared";
var radarChartAdapter = {
    type: "radar",
    buildOption: function (ctx) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var data = ctx.data;
        var settings = mergeRadarSettings(ctx.settings);
        var legend = buildLegend(data.legend, settings.legend);
        var tooltip = buildTooltip(data.tooltip, {
            trigger: (_b = (_a = settings.tooltip) === null || _a === void 0 ? void 0 : _a.trigger) !== null && _b !== void 0 ? _b : "item",
            enable: (_c = settings.tooltip) === null || _c === void 0 ? void 0 : _c.enable,
            formatter: (_d = settings.tooltip) === null || _d === void 0 ? void 0 : _d.formatter,
        });
        var radar = {
            shape: (_e = settings.shape) !== null && _e !== void 0 ? _e : "polygon",
            splitNumber: (_f = settings.splitNumber) !== null && _f !== void 0 ? _f : 5,
            indicator: data.indicators.map(function (indicator) { return ({
                name: indicator.name,
                max: indicator.max,
                min: indicator.min,
            }); }),
        };
        var showSymbol = (_g = settings.showSymbol) !== null && _g !== void 0 ? _g : true;
        var areaDefault = (_h = settings.areaDefault) !== null && _h !== void 0 ? _h : false;
        var series = [
            {
                type: "radar",
                symbol: showSymbol ? "circle" : "none",
                symbolSize: showSymbol ? 6 : 0,
                data: data.series.map(function (seriesItem) {
                    var _a;
                    return ({
                        name: seriesItem.name,
                        value: seriesItem.values.map(function (value) {
                            return typeof value === "number" ? value : 0;
                        }),
                        lineStyle: seriesItem.lineWidth
                            ? { width: seriesItem.lineWidth }
                            : undefined,
                        itemStyle: seriesItem.color ? { color: seriesItem.color } : undefined,
                        areaStyle: ((_a = seriesItem.area) !== null && _a !== void 0 ? _a : areaDefault)
                            ? {
                                opacity: 0.25,
                                color: seriesItem.color,
                            }
                            : undefined,
                    });
                }),
            },
        ];
        var option = {
            tooltip: tooltip,
            legend: legend,
            radar: radar,
            series: series,
        };
        return option;
    },
    getDefaultSettings: function () { return ({
        legend: { show: true, position: "top" },
        tooltip: { enable: true, trigger: "item" },
        shape: "polygon",
        splitNumber: 5,
        showSymbol: true,
        areaDefault: false,
    }); },
};
export default radarChartAdapter;
